import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import LegalCenter from "@/pages/LegalCenter";
import LegalDoc from "@/pages/LegalDoc";
import ManageData from "@/pages/ManageData";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App grain">
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/legal" element={<LegalCenter />} />
            <Route path="/legal/:slug" element={<LegalDoc />} />
            <Route path="/manage-data" element={<ManageData />} />
            <Route path="*" element={<Landing />} />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </div>
    </MotionConfig>
  );
}

export default App;
